/* DOKS STUDIO — behaviour layer.
   Mirrors what the Next.js build did: custom cursor, scroll reveals, a hide-on-scroll
   header, the overlays, and an AJAX cart. No framework, no dependencies. */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fine = window.matchMedia('(pointer: fine)').matches;  // used by the image zoom

  /* ---------- header: transparent over a dark hero, legible everywhere ----
     State lives in a data attribute with real CSS behind it, so the scrolled
     header can never end up transparent-with-pale-text again. */
  (function () {
    var header = $('[data-header]');
    if (!header) return;
    var overHero = header.getAttribute('data-over-hero') === 'true';
    var last = 0;

    var apply = function () {
      var y = window.scrollY;
      header.setAttribute('data-state', (overHero && y <= 40) ? 'over' : 'solid');
      // slide away while scrolling down past the fold, return on the way up
      if (y > 400 && y > last + 4) header.classList.add('-translate-y-full');
      else if (y < last - 4 || y <= 400) header.classList.remove('-translate-y-full');
      last = y;
    };
    window.addEventListener('scroll', apply, { passive: true });
    apply();
  })();

  /* ---------- dropdowns: hover is CSS, this adds touch and keyboard ------ */
  (function () {
    var groups = $$('[data-submenu]');
    if (!groups.length) return;
    var coarse = window.matchMedia('(hover: none)').matches;

    groups.forEach(function (g) {
      var trigger = $('.doks-menu-trigger', g);
      if (!trigger) return;

      if (coarse) {
        // first tap opens, second follows the link
        trigger.addEventListener('click', function (e) {
          if (g.getAttribute('data-open') !== 'true') {
            e.preventDefault();
            groups.forEach(function (o) { if (o !== g) o.setAttribute('data-open', 'false'); });
            g.setAttribute('data-open', 'true');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      }
      g.addEventListener('focusin', function () { trigger.setAttribute('aria-expanded', 'true'); });
      g.addEventListener('focusout', function () {
        if (!g.contains(document.activeElement)) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-submenu]')) return;
      groups.forEach(function (g) {
        g.setAttribute('data-open', 'false');
        var tr = $('.doks-menu-trigger', g);
        if (tr) tr.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      groups.forEach(function (g) { g.setAttribute('data-open', 'false'); });
    });
  })();

  /* ---------- generic overlay open/close --------------------------------- */
  function openEl(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeEl(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 350);
  }

  var menu   = $('[data-mobile-menu]');
  var drawer = $('[data-cart-drawer]');
  var search = $('[data-search-overlay]');

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  $$('[data-open-menu]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-close-menu]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  /* accordion sections inside the mobile menu — one open at a time */
  $$('[data-m-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-m-group]');
      var isOpen = group.getAttribute('data-open') === 'true';
      $$('[data-m-group]').forEach(function (g) {
        g.setAttribute('data-open', 'false');
        var b = $('[data-m-toggle]', g);
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      group.setAttribute('data-open', isOpen ? 'false' : 'true');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function () { openEl(drawer); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { closeEl(drawer); }); });
  $$('[data-open-search]').forEach(function (b) {
    b.addEventListener('click', function () { openEl(search); var i = $('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 120); });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { closeEl(search); }); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [drawer, search].forEach(function (el) { if (el && !el.hidden) closeEl(el); });
    // the newsletter modal is dismissable the same way as any other dialog
    var npop = $('[data-newsletter-popup]');
    if (npop && !npop.hidden) {
      npop.hidden = true;
      try { localStorage.setItem('doks-newsletter', 'dismissed'); } catch (err) {}
    }
    if (menu && menu.classList.contains('is-open')) closeMenu();
  });

  /* ---------- predictive search ------------------------------------------ */
  (function () {
    var input = $('[data-search-input]'), out = $('[data-search-results]');
    if (!input || !out) return;
    var timer, controller;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        fetch(window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8&section_id=predictive-search',
              { signal: controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var grid = doc.querySelector('[data-predictive-grid]');
            out.innerHTML = grid ? grid.innerHTML : '';
          })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ---------- product: gallery, sizes, quantity, accordions -------------- */
  (function () {
    var slides = $$('[data-slide]');
    if (slides.length) {
      var idx = 0;
      var show = function (n) {
        idx = Math.max(0, Math.min(slides.length - 1, n));
        slides.forEach(function (im, i) { im.hidden = i !== idx; });
        $$('[data-thumb]').forEach(function (t, i) {
          t.className = 'relative shrink-0 w-14 h-[70px] md:w-full md:h-[88px] overflow-hidden transition-all duration-300 ' +
            (i === idx ? 'ring-1 ring-obsidian' : 'ring-1 ring-transparent opacity-40 hover:opacity-70');
        });
        var prev = $('[data-prev]'), next = $('[data-next]');
        if (prev) prev.disabled = idx === 0;
        if (next) next.disabled = idx === slides.length - 1;
      };
      $$('[data-thumb]').forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.thumb); }); });
      var p = $('[data-prev]'), n = $('[data-next]');
      if (p) p.addEventListener('click', function () { show(idx - 1); });
      if (n) n.addEventListener('click', function () { show(idx + 1); });
      show(0);

      var zoom = $('[data-zoom]');
      if (zoom && fine) {
        zoom.addEventListener('mousemove', function (e) {
          var r = zoom.getBoundingClientRect();
          var img = slides[idx];
          if (!img) return;
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          img.style.transform = 'scale(1.8)';
        });
        zoom.addEventListener('mouseleave', function () {
          slides.forEach(function (im) { im.style.transform = ''; });
        });
      }
    }

    $$('[data-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-size]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var input = $('[data-variant-input]');
        if (input) input.value = btn.dataset.variantId;
        var price = $('[data-price]');
        if (price && btn.dataset.price) price.innerHTML = btn.dataset.price;
      });
    });

    var qty = $('[data-qty]');
    if (qty) {
      var step = function (d) {
        var v = parseInt(qty.value, 10); if (isNaN(v)) v = 1;
        qty.value = Math.max(1, v + d);
      };
      var m = $('[data-qty-minus]'), pl = $('[data-qty-plus]');
      if (m) m.addEventListener('click', function () { step(-1); });
      if (pl) pl.addEventListener('click', function () { step(1); });
    }

    $$('[data-accordion]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var body = btn.nextElementSibling;
        if (body) {
          body.setAttribute('aria-hidden', String(open));
          body.classList.toggle('is-open', !open);
        }
        var icon = $('[data-accordion-icon]', btn);
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });
  })();

  /* ---------- AJAX cart --------------------------------------------------- */
  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer-items')
      .then(function (r) { return r.text(); })
      .then(function () { return fetch(window.Shopify.routes.root + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
        var c = $('[data-cart-drawer-count]');
        if (c) c.textContent = '(' + cart.item_count + ')';
        // re-render the drawer body straight from the cart page
        return fetch(window.Shopify.routes.root + 'cart?view=drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var body = doc.querySelector('[data-cart-body]');
            var foot = doc.querySelector('[data-cart-foot]');
            var curBody = $('[data-cart-body]'), curFoot = $('[data-cart-foot]');
            if (body && curBody) curBody.innerHTML = body.innerHTML;
            if (foot && curFoot) { curFoot.innerHTML = foot.innerHTML; curFoot.hidden = cart.item_count === 0; }
            bindLines();
          });
      });
  }

  function bindLines() {
    $$('[data-line-plus],[data-line-minus]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.dataset.lineIndex;
        var row = b.closest('[data-line]');
        var span = row ? row.querySelector('span.w-7') : null;
        var cur = span ? parseInt(span.textContent, 10) : 1;
        var next = b.hasAttribute('data-line-plus') ? cur + 1 : cur - 1;
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(line), quantity: Math.max(0, next) })
        }).then(refreshCart);
      });
    });
  }
  bindLines();

  /* ---------- cart page: steppers without a full reload ------------------
     The markup posts correctly on its own (updates[] + the Обнови button), so
     this is pure enhancement; if anything here throws, the form still works. */
  (function () {
    var form = $('[data-cart-form]');
    if (!form) return;

    var busy = false;
    var capped = null;
    function setLine(line, qty) {
      if (busy) return;
      busy = true;
      form.style.opacity = '.55';
      var wanted = Math.max(0, qty);
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: wanted })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // stock is capped per variant, so a + press can legitimately do nothing;
          // say so instead of looking broken
          var got = (cart.items && cart.items[Number(line) - 1]) ? cart.items[Number(line) - 1].quantity : 0;
          capped = (wanted > 0 && got < wanted) ? got : null;
          return fetch(window.Shopify.routes.root + 'cart');
        })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-form]');
          var page = doc.querySelector('.bg-chalk.min-h-screen');
          if (fresh) {
            form.innerHTML = fresh.innerHTML;
            bind();
            if (capped !== null) notice(line, capped);
          } else if (page) {
            // cart went empty — that template has no form, so swap the shell
            var shell = form.closest('.bg-chalk');
            if (shell && shell.parentNode) shell.parentNode.replaceChild(page, shell);
          }
          return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('hidden', cart.item_count === 0);
          });
        })
        .catch(function () { window.location.reload(); })
        .finally(function () { busy = false; form.style.opacity = ''; });
    }

    function notice(line, max) {
      var row = form.querySelector('[data-line="' + line + '"]');
      if (!row) return;
      var old = row.querySelector('[data-stock-note]');
      if (old) old.remove();
      var el = document.createElement('p');
      el.setAttribute('data-stock-note', '');
      el.className = 'font-sans text-[0.65rem] mt-2';
      el.style.color = '#b45309';
      el.textContent = (window.DOKS_STOCK_MSG || 'Налично количество: ') + max;
      row.appendChild(el);
      setTimeout(function () { if (el.parentNode) el.remove(); }, 6000);
    }

    function bind() {
      $$('[data-line-minus]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.dataset.lineIndex;
          var input = form.querySelector('[data-line-qty][data-line-index="' + i + '"]');
          setLine(i, (parseInt(input.value, 10) || 1) - 1);
        });
      });
      $$('[data-line-plus]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.dataset.lineIndex;
          var input = form.querySelector('[data-line-qty][data-line-index="' + i + '"]');
          setLine(i, (parseInt(input.value, 10) || 0) + 1);
        });
      });
      $$('[data-line-qty]', form).forEach(function (input) {
        input.addEventListener('change', function () {
          setLine(input.dataset.lineIndex, parseInt(input.value, 10) || 0);
        });
      });
      $$('[data-line-remove]', form).forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          setLine(a.dataset.lineIndex, 0);
        });
      });
    }
    bind();
  })();

  var addForm = $('[data-add-form]');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add-btn]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(addForm) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          return refreshCart();
        })
        .then(function () { openEl(drawer); })
        .catch(function (err) { alert(err.message); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  }

  /* ---------- newsletter popup + cookie banner --------------------------- */
  (function () {
    var store = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } };

    var cookie = $('[data-cookie-banner]');
    if (cookie && !store('doks-cookie')) {
      setTimeout(function () { cookie.hidden = false; }, 900);
      $$('[data-cookie-accept],[data-cookie-decline]', cookie).forEach(function (b) {
        b.addEventListener('click', function () {
          store('doks-cookie', b.hasAttribute('data-cookie-accept') ? 'accepted' : 'declined');
          cookie.hidden = true;
        });
      });
    }

    var pop = $('[data-newsletter-popup]');
    if (pop && !store('doks-newsletter')) {
      setTimeout(function () { pop.hidden = false; }, (window.DOKS_POPUP_DELAY || 6) * 1000);
      $$('[data-popup-close]', pop).forEach(function (b) {
        b.addEventListener('click', function () { store('doks-newsletter', 'dismissed'); pop.hidden = true; });
      });
      var f = pop.querySelector('form');
      if (f) f.addEventListener('submit', function () { store('doks-newsletter', 'subscribed'); });
    }
  })();
})();
